import optional from '@nullvoxpopuli/ember-composable-helpers/helpers/optional';
import { t } from 'ember-intl';
import BvBtn from 'volta/components/bv-btn';
import BvInline from 'volta/components/bv-inline';
import BvText from 'volta/components/bv-text';
import classNames from 'volta/helpers/class-names';
import orElse from 'volta/helpers/or-else';

import type { TOC } from '@ember/component/template-only';

export interface BvModalHeaderSignature {
  Args: {
    hideCloseButton?: boolean;
    onClose?: () => void;
    subdued?: boolean;
    subtitle?: string;
    title?: string;
    titleAction?: () => void;
    titleLinkIcon?: string;
  };
  Blocks: {
    default: [];
    titleAction: [];
  };
  Element: HTMLElement;
}

const BvModalHeaderComponent: TOC<BvModalHeaderSignature> = <template>
  <header
    class={{classNames
      'bv-modal__header'
      (unless @title 'bv-modal__header--without-title')
      (if @subdued 'bv-modal__header--subdued')
    }}
    ...attributes
  >
    {{#if @title}}
      <BvInline @gap='2' @wrap={{false}} class='bv-modal__title u-ellipsis'>
        <BvText @variant='heading-md' class={{unless @subtitle 'u-ellipsis'}}>
          {{@title}}
        </BvText>
        {{#if @subtitle}}
          <BvText @color='subdued' @text={{@subtitle}} class='u-ellipsis' />
        {{/if}}
        {{#if @titleAction}}
          <BvBtn
            @size='sm'
            @subtle={{true}}
            @iconLeft={{orElse @titleLinkIcon 'link'}}
            @onClick={{@titleAction}}
          />
        {{/if}}
        {{yield to='titleAction'}}
      </BvInline>
    {{/if}}
    {{#if (has-block)}}
      <div class='bv-modal__header-info u-d-flex u-align-items-center'>
        {{yield}}
      </div>
    {{/if}}
    {{#unless @hideCloseButton}}
      <BvBtn
        class='bv-modal__close'
        @onClick={{optional @onClose}}
        @accessibilityLabel={{t 'close'}}
        @subtle={{true}}
        @iconLeft='close'
      />
    {{/unless}}
  </header>
</template>;

export default BvModalHeaderComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvModal::Header': typeof BvModalHeaderComponent;
    'bv-modal/header': typeof BvModalHeaderComponent;
  }
}
